import React, { useEffect, useState } from "react";
import { Link, json } from "react-router-dom";
import { buscarConfiguracion } from "../../helpers/helpers";
import useAlumno from "../../hooks/useAlumno";
import ButtonZegel from "../Buttons/ButtonZegel";
import "./styles/CardCurso.scss";
import { PrivateRoutes } from "../../routes/routes";
import { useNavigate } from "react-router-dom";
import { RegistrarAsignarCurso } from "../../services/UsuarioService";

const CardCursoExplorar = ({ curso }) => {
  const { configuraciones, perfil } = useAlumno();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const porcentajeDescuento = buscarConfiguracion(
    configuraciones,
    "DCTO_CURSOS"
  );
  const AsignarCurso = () => {
    setLoading(true)
    let jwt = window.localStorage.getItem("jwt");

    let idCurso = curso.idCurso;
    let fechaVigencia = new Date();
    let idUsuario = perfil.idUsuario;

    let jsonCurso = JSON.stringify(
      { idUsuario, idCurso, fechaVigencia },
      null,
      2
    );
    RegistrarAsignarCurso({ jsonCurso, jwt })
      .then((data) => {
        setLoading(false)
        window.location.reload(false)
      })
      .catch((errors) => {
        setLoading(false)
        alert("ocurrió un error: " + errors.message);
      });
  };

  return (
    <>
      <div className="card-curso">
        <div className="card-curso-header">
          <img
            src={curso.fotoCurso}
            className="c-user-course-card__banner"
            style={{ width: "100%", height: "auto" }}
          />
          <h2 className="mb-0">{curso.nombre}</h2>
        </div>
        <div className="card-curso-contenido">
          <div className="flex align-items-center gap-4 aditional-info mt-3">
            <div className="flex align-items-center gap-2">
              <p>{curso.duracion}</p>
              <i className="pi pi-clock" style={{ fontSize: "10.45px" }}></i>
            </div>

            <p>
              <strike>
                S/{" "}
                {(
                  parseFloat(curso.precio) /
                  (1 - porcentajeDescuento / 100)
                ).toFixed(2)}
              </strike>
            </p>
            {curso.precio && (
              <p style={{ fontSize: 16, fontWeight: "bold" }}>
                S/
                {parseFloat(curso.precio).toFixed(2)}
              </p>
            )}
          </div>

          <div className="boton-accion">
            <div className="">
              <Link
                to={
                  "https://zegelvirtual.com/cursos-virtuales/" + curso.urlRetail
                }
                target="_blank"
              >
                <ButtonZegel
                  label="Conoce más del curso"
                  color="secondary"
                ></ButtonZegel>
              </Link>
              {perfil && perfil.membresia === true && (
                <div className="mt-2">
                  <ButtonZegel
                    label="Activar curso"
                    color="terceary"
                    onClick={()=>AsignarCurso()}
                    loading = {loading}
                  ></ButtonZegel>
                </div>
              )}
            </div>
            {/* <div>
            <ButtonZegel label="Mi progreso" color="secondary"></ButtonZegel>
          </div> */}
          </div>
        </div>
      </div>
      <div className="card-curso-mobile">
        <div className="curso-mobile-header flex align-items-star gap-2">
          <div className="mobile-header-img">
            <img src={curso.fotoCurso} className="c-user-course-card__banner" />
          </div>
          <div className="mobile-header-contenido ">
            <div className="header-contenido-titulo">
              <label className="mb-0">{curso.nombre}</label>
            </div>
            <div className="header-contenido-adicional">
              <div className="flex align-items-center gap-2 ">
                <p style={{ fontSize: 12 }}>{curso.duracion}</p>
                <i className="pi pi-clock" style={{ fontSize: "10.45px" }}></i>
              </div>
              <div className="flex align-items-center gap-2 h-1rem">
                <p style={{ fontSize: 10 }}>
                  <strike>
                    S/ {parseFloat(curso.precio).toFixed(2) * 1.25}
                  </strike>
                </p>
                {curso.precio && (
                  <p style={{ fontSize: 12, fontWeight: "bold" }}>
                    S/
                    {parseFloat(curso.precio).toFixed(2)}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="boton-accion mt-2">
          <div>
            <Link
              to={
                "https://zegelvirtual.com/cursos-virtuales/" + curso.urlRetail
              }
              target="_blank"
            >
              <ButtonZegel
                label="Conoce más del curso"
                color="secondary"
              ></ButtonZegel>
              
            </Link>
            {perfil && perfil.membresia === true && (
                <div className="mt-2">
                  <ButtonZegel
                    label="Activar curso"
                    color="terceary"
                    onClick={()=>AsignarCurso()}
                    loading = {loading}
                  ></ButtonZegel>
                </div>
              )}
          </div>
          {/* <div>
            <ButtonZegel label="Mi progreso" color="secondary"></ButtonZegel>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default CardCursoExplorar;
